import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { OrdiniApi, GetOrdiniRequest } from "../data/apis/OrdiniApi";
import { GetOrdiniFilter } from "../data/models/GetOrdiniFilter";

export function ordersDataSource(filter: GetOrdiniFilter) {
    return new CustomStore({
        key: "idOrdine",
        loadMode: 'raw',
        load: (loadOptions) => {
            const api = new OrdiniApi(apiConfiguration);

            return api.getOrdini({
                filter: filter
            });
        },

        byKey: (key) => {
            const api = new OrdiniApi(apiConfiguration);

            return api.getOrdineById({
                idOrdine: key
            });
        },

        insert: (values) => {
            const api = new OrdiniApi(apiConfiguration);

            return api.insertOrdine({
                ordineCreateDTO: values
            });
        },

        update: (key, values) => {
            const api = new OrdiniApi(apiConfiguration);
            return api.updateOrdine({
                idOrdine: key,
                ordineUpdateDTO: values
            });
        },

        remove: (key) => {
            const api = new OrdiniApi(apiConfiguration);
            return api.deleteOrdine({
                idOrdine: key
            });
        }
       
    });
}
